import React, { useState } from 'react';
import axios from 'axios';
import { FaTimes, FaLock, FaEnvelope } from 'react-icons/fa';
import { useApp } from '../App';
import './LoginModal.css';

function LoginModal({ onClose }) {
  const { setManager } = useApp();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      // 👇 FIXED: Added the full API subdomain URL
      const r = await axios.post('https://api.hospifylink.com/api/manager/login', { 
        email, 
        password 
      });
      
      localStorage.setItem('lca_token', r.data.token);
      setManager(r.data.manager);
      onClose();
      
      // Redirect to manager dashboard (standardizing on /manager)
      window.location.href = '/manager'; 
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    }
    setLoading(false);
  };

  return (
    <div className="loginmodal-root" onClick={onClose}>
      <div className="loginmodal-box" onClick={e => e.stopPropagation()}>
        <button className="loginmodal-close" onClick={onClose}><FaTimes /></button>

        <div className="loginmodal-brand">
          <span>HOSPIFY <span className="loginmodal-brand-accent">LINK</span></span>
        </div>

        <h2>Manager Login</h2>
        <p>Sign in to access the dashboard</p>

        <form onSubmit={submit}>
          <div className="loginmodal-field">
            <FaEnvelope className="loginmodal-icon" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="loginmodal-field">
            <FaLock className="loginmodal-icon" />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="loginmodal-error">{error}</p>}
          <button type="submit" className="lca-btn-primary" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginModal;